import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, BookOpenIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const MethodologyAccordion: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden print:shadow-none print:border print:border-gray-300 print:break-inside-avoid" data-id="element-448">
      

      <AnimatePresence data-id="element-449">
        {isExpanded && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-450">
            <div className="p-6 md:p-8 pt-0 border-t border-gray-100 bg-gray-50/50" data-id="element-451">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-452">
                <div data-id="element-453">
                  <h4 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-454">
                    Data Collection
                  </h4>
                  <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-455">
                    BrandPulse tracks anonymized user behavior across a premium
                    publisher network reaching 85% of the Dutch online
                    population. We analyze "Human Signals"—verified interactions
                    such as reading time, scroll depth, and search behavior—to
                    measure genuine interest rather than just impressions.
                  </p>
                  <ul className="space-y-2" data-id="element-456">
                    <li className="flex items-start space-x-2 text-sm text-gray-600" data-id="element-457">
                      <span className="w-1.5 h-1.5 bg-[#1E90FF] rounded-full mt-2 flex-shrink-0" data-id="element-458" />
                      <span data-id="element-459">
                        <strong className="text-gray-900" data-id="element-460">279,000+</strong>{' '}
                        Human Signals analyzed
                      </span>
                    </li>
                    <li className="flex items-start space-x-2 text-sm text-gray-600" data-id="element-461">
                      <span className="w-1.5 h-1.5 bg-[#1E90FF] rounded-full mt-2 flex-shrink-0" data-id="element-462" />
                      <span data-id="element-463">
                        <strong className="text-gray-900" data-id="element-464">
                          GDPR Compliant:
                        </strong>{' '}
                        100% privacy-safe, no PII collected
                      </span>
                    </li>
                  </ul>
                </div>
                <div data-id="element-465">
                  <h4 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-466">
                    Statistical Analysis
                  </h4>
                  <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-467">
                    We use a Bayesian structural time-series model to calculate
                    uplift. This compares the observed behavior in the exposed
                    group against a synthetic control group (counterfactual)
                    constructed from unexposed audiences with similar behavioral
                    traits.
                  </p>
                  <ul className="space-y-2" data-id="element-468">
                    <li className="flex items-start space-x-2 text-sm text-gray-600" data-id="element-469">
                      <span className="w-1.5 h-1.5 bg-[#1E90FF] rounded-full mt-2 flex-shrink-0" data-id="element-470" />
                      <span data-id="element-471">
                        <strong className="text-gray-900" data-id="element-472">
                          97.5% Confidence:
                        </strong>{' '}
                        High statistical significance
                      </span>
                    </li>
                    <li className="flex items-start space-x-2 text-sm text-gray-600" data-id="element-473">
                      <span className="w-1.5 h-1.5 bg-[#1E90FF] rounded-full mt-2 flex-shrink-0" data-id="element-474" />
                      <span data-id="element-475">
                        <strong className="text-gray-900" data-id="element-476">
                          Control Group:
                        </strong>{' '}
                        Synthetic counterfactual baseline
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};